/* import __COLOCATED_TEMPLATE__ from './parent-category-row.hbs'; */
import CategoryListItem from "discourse/components/category-list-item";

export default class ParentCategoryRow extends CategoryListItem {}
